import useFormReview from "./useFormReview";
import { useReviewNavigation } from "../components/ReviewWizard/useReviewNavigation";

export const useFormReviewShell = ({
  applicationId,
  autoLoad = true,
  onLoadError,
  onPersistError,
  fieldDefinitions = {},
  formData = null,
  currentWizard = "",
  wizardOrder = [],
  onNavigateToWizard,
}) => {
  const reviewState = useFormReview(applicationId, {
    autoLoad,
    onLoadError,
  });

  const reviewNavigation = useReviewNavigation({
    formReview: reviewState.formReview,
    setFormReview: reviewState.setFormReview,
    persistFormReview: reviewState.persistFormReview,
    fieldDefinitions,
    formData,
    currentWizard,
    wizardOrder,
    onNavigateToWizard,
    onPersistError,
  });

  return {
    ...reviewState,
    reviewError: reviewState.error,
    reviewLoading: reviewState.loading,
    reviewNavigation,
  };
};

export default useFormReviewShell;
